import http from "@/http";

//###  参数配置列表
//  http://base.leubao.com/api/config/list
export const getConfigList = {
  p: "/api/config/list",
  r: data => {
    return http({
      url: "/api/config/list",
      method: "post",
      data
    });
  }
};
//###  参数配置详情
//  http://base.leubao.com/api/config/details/1
export const getNoticeInfo = {
  p: "/api/config/details",
  r: data => {
    return http({
      url: "/api/config/details/" + data.id,
      method: "get"
    });
  }
};
//### 添加参数配置
//  http://base.leubao.com/api/config/add
export const addConfig = {
  p: "/api/config/add",
  r: data => {
    return http({
      url: "/api/config/add",
      method: "post",
      data
    });
  }
};
//### 参数配置修改
// http://base.leubao.com/api/config/edit
export const etidConfig = {
  p: "/api/config/edit",
  r: data => {
    return http({
      url: "/api/config/edit",
      method: "post",
      data
    });
  }
};
//### 删除参数配置
// http://base.leubao.com/api/config/delete
export const deleteConfig = {
  p: "/api/config/delete",
  r: data => {
    return http({
      url: "/api/config/delete",
      method: "post",
      data
    });
  }
};
